import { recordTrack } from '@saucelabs/sl-util-segmentio';

import * as actions from './actions';


export const trackedToggleJobFilter = (status, metadata = {}) => (dispatch) => {
  dispatch(actions.toggleStatus(status));
  dispatch(recordTrack('Toggled job filter', { ...metadata, status }));
};
